import { FC } from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import Counter, { CounterProps } from "components/Counter";
import { COUNTER_SIZES } from "components/Counter/sizes";

import styles from "./styles";

export type SubHeaderProps = {
  header?: string;
  subheader?: string;
  description?: string;
  background?: string;
  textColor?: "dark" | "textSecondary";
  counter?: CounterProps | null;
  modifiedBackground?: boolean;
  isBackgroundGradient?: boolean;
};

const SubHeader: FC<SubHeaderProps> = ({
  header = "",
  subheader = "",
  description = "",
  background,
  textColor = "textPrimary",
  counter = null,
  modifiedBackground = false,
  isBackgroundGradient = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={[
        styles.positionRelative,
        !modifiedBackground
          ? (theme) => styles.wrapper(theme, !!background)
          : {},
        modifiedBackground && styles.modifiedWrapper,
      ]}
    >
      <Box
        sx={styles.image(theme, {
          isBackgroundSet: !!background,
          isBackgroundGradient: isBackgroundGradient,
          url: background,
        })}
      >
        {header && (
          <Typography
            component="h1"
            variant="h1"
            sx={{ textAlign: { xs: "center" } }}
            color={textColor}
            gutterBottom={!isMobile}
          >
            {header}
          </Typography>
        )}

        {subheader && (
          <Box sx={{ width: { xs: "95%", md: "80%" } }}>
            <Typography
              variant={isMobile ? "subtitle1" : undefined}
              sx={{ textAlign: { xs: "center" }, whiteSpace: "pre-line" }}
              color={textColor}
              fontWeight={500}
            >
              {subheader}
            </Typography>
          </Box>
        )}

        {description && (
          <Typography sx={{ textAlign: { xs: "center" } }} color={textColor}>
            {description}
          </Typography>
        )}

        {counter && <Counter size={COUNTER_SIZES.BIG} {...counter} />}
      </Box>
    </Box>
  );
};

export default SubHeader;
